// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3uK2K","rootCenter":"LoadMoreObserver_rootCenter__2x2LH","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1GVjt"};